import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {CrystalLightboxModule} from '@crystalui/angular-lightbox';
import { NgPipesModule } from 'ngx-pipes';
import { NgxLoadersCssModule } from 'ngx-loaders-css';
import { FileUploadModule } from 'primeng/fileupload';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng5SliderModule } from 'ng5-slider';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/layout/header/header.component';
import { FooterComponent } from './components/layout/footer/footer.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FilterComponent } from './components/pages/filter/filter.component';
import {CarsModel} from './model/car.model';
import { SortByPipe } from './pipe/sort-by.pipe';
import { SliderComponent } from './components/pages/slider/slider.component';
import { CarDetailsComponent } from './components/pages/car-details/car-details.component';
import { ContactFormComponent } from './components/pages/car-details/contact-form/contact-form.component';
import { ShowroomComponent } from './components/pages/showroom/showroom.component';
import { FinanceFormComponent } from './components/pages/car-details/finance-form/finance-form.component';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    FilterComponent,
    SortByPipe,
    SliderComponent,
    CarDetailsComponent,
    ContactFormComponent,
    ShowroomComponent,
    FinanceFormComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    SlickCarouselModule,
    FormsModule,
    ReactiveFormsModule,
    NgPipesModule,
    HttpClientModule,
    CrystalLightboxModule,
    NgxPaginationModule,
    NgxLoadersCssModule,
    FileUploadModule,
    Ng5SliderModule
  ],
  providers: [CarsModel],
  bootstrap: [AppComponent]
})
export class AppModule { }
